import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

export const AccountHoldingsTab = () => (
    <div className="pt-5">
        <Outlet />
    </div>
);

const triggerClass =
    'h-9 rounded-md border-0 px-4 text-sm font-medium text-stone-500 hover:border-transparent data-[state=active]:bg-white data-[state=active]:font-semibold data-[state=active]:text-stone-900 data-[state=active]:shadow-sm';

export const HoldingsViewToggle = () => {
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();
    const base = pathname.slice(0, pathname.lastIndexOf('/holdings') + '/holdings'.length);
    const tab = pathname.includes('/holdings/lots') ? 'lots' : 'positions';

    return (
        <div className="flex items-center gap-3">
            <Tabs
                value={tab}
                onValueChange={(value) => navigate(`${base}/${value === 'lots' ? 'lots/open' : value}${search}${hash}`)}
            >
                <TabsList aria-label="Holdings view" className="h-11 gap-0 rounded-lg border-0 bg-stone-100 p-1">
                    <TabsTrigger value="positions" className={triggerClass}>
                        Positions
                    </TabsTrigger>
                    <TabsTrigger value="lots" className={triggerClass}>
                        Open Lots
                    </TabsTrigger>
                </TabsList>
            </Tabs>
        </div>
    );
};
